import React, { Component } from 'react';
import{
    Container,
    Col,
    Row,
    Button,
    Table,
    Modal,
    ModalBody,
    ModalFooter,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Input
} from 'reactstrap';
import SelectCliente from '../components/Cliente/SelectCliente'
import SelectFattura from '../components/NuovoVersamenti/SelectFattura';
/**
 * Used for the Listino Prezzi section. 
 */
class NuovoVersamentiContainer extends Component {

    constructor(props) {
        super(props);

        this.toggleClienteSelectModal = this.toggleClienteSelectModal.bind(this);
        this.toggleEntryModal = this.toggleEntryModal.bind(this);
        this.toggleFatturaModal = this.toggleFatturaModal.bind(this);
        this.toggleTitoloPagamenti = this.toggleTitoloPagamenti.bind(this);
        this.toggleErrorModal = this.toggleErrorModal.bind(this);

        this.state = {
            pendingVersamenti: [],
            nonApprovVersamenti: [],
            clienti: [],
            searchClienti: [],
            searchCodiceClienti: [],
            fatture: [],
            searchFatture: [],
            versamento: {},
            fattura: null,
            fatt: '',
            titoloPagamenti: [],
            titoloPagamentoId: '',
            textTitoloDropdown: 'Scegli un Titolo Pagamento',
            titoloPagamentiDropdown: false,
            note: '',
            entryModal: false,
            clientiModal: false,
            fatturaModal: false,
            errorModal: false,
            isView: true,
            searchComplete: false,
            searchCodiceComplete: false,
            fattureSearchComplete: false,
            cliente: null,
            importo: '',
            dataDa: '',
            dataA: '',
            importoDa: '',
            importoA: '',
            historicalFilter: {
                dataDa: '',
                dataA: '',
                importoDa: '',
                importoA: '',
            },
            errore: '',
        };
    
    }

    
    /**
     * Runs upon initial mount of the /listinoPrezzi path
     */
    componentDidMount(){
          this.getVersamenti();
    }    

    getVersamenti = () => {
        const role = sessionStorage.getItem("selectedRole");

          let url = '';

          if(role === "Agenti"){
            url = '/api/versamenti';
          }
          else if(role === "Amministrazione"){
            url = '/api/amministrazione/versamenti';
          }

          fetch(url, {   
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            console.log(myjson)
            this.setState({
                pendingVersamenti: myjson.pending,
                nonApprovVersamenti: myjson.nonApprov ? myjson.nonApprov : []
            }, () => console.log(this.state.nonApprovVersamenti))
        }).catch(e => {

        });
    }

    toggleEntryModal = (isNew) => {

        if(this.state.entryModal){
            this.setState({
                entryModal: !this.state.entryModal,
                cliente: null,
            }, () => this.getVersamenti())
        }
        else{
            this.setState({
                isView: isNew ? false : true,
                entryModal: !this.state.entryModal,
            }, () => {
                this.getClienti();
                //this.getTitoloPagamenti();
            })
        }
        
    }

    getClienti = () => {
        const form = {
            Informazione: "",
            CurrentRole: sessionStorage.getItem("selectedRole")
        };

        fetch(`../api/clienti/cerca`, {   
            method: 'POST',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Sets the body of the call
            body: JSON.stringify(form)
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            this.setState({
                clienti: myjson,
            })
        }).catch(e => {

        });
    }

    toggleClienteSelectModal = () => {
        this.setState({
            clientiModal: !this.state.clientiModal,
        })
    }

    toggleFatturaModal = () => {
        console.log(this.state.fatturaModal)
        if(!this.state.fatturaModal){
            this.setState({
                fatturaModal: !this.state.fatturaModal,
                fattureSearchComplete: false
            }) 
        }
        else{
            this.setState({
                fatturaModal: !this.state.fatturaModal,
            }, () => console.log(this.state.fatturaModal))
        }
        
    }

    clienteSelected = (cliente) => {
        console.log(cliente)
        if(cliente){
            this.setState({
                cliente: cliente
            }, () => {
                this.toggleClienteSelectModal()
                this.getFatture();
                this.getTitoloPagamenti();
            });
        }
        else{
            this.toggleClienteSelectModal();
        }
    }

    clienteSearch = (text) => {
        console.log(text);
        if(!text){
            this.setState({
                searchClienti: [],
                searchComplete: false
            })
        }
        else{
            const form = {
                Informazione: text,
                CurrentRole: sessionStorage.getItem("selectedRole")
            };
    
            fetch(`../api/clienti/cerca`, {   
                method: 'POST',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Sets the body of the call
                body: JSON.stringify(form)
                //Changes the response to an object
            }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    searchClienti: myjson,
                    searchComplete: true,
                })
    
            }).catch(e => {
    
            });
        }
    } 

    clienteCodiceSearch = (text) => {
        console.log(text);
        if(!text){
            this.setState({
                searchCodiceClienti: [],
                searchCodiceComplete: false
            })
        }
        else{
            const form = {
                Informazione: text,
                CurrentRole: sessionStorage.getItem("selectedRole")
            };
            console.log(form)
            fetch(`../api/clienti/cercaCodice`, {   
                method: 'POST',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Sets the body of the call
                body: JSON.stringify(form)
                //Changes the response to an object
            }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    searchCodiceClienti: myjson,
                    searchCodiceComplete: true,
                })
    
            }).catch(e => {
    
            });
        }
    } 

    fatturaSelected = (fattura) => {
        
        this.setState({
            fattura: fattura
        }, () => this.toggleFatturaModal())
    }

    fatturaSearch = () => {
        this.setState({
            historicalFilter: {
                dataDa: this.state.dataDa,
                dataA: this.state.dataA,
                importoDa: this.state.importoDa,
                importoA: this.state.importoA
            },
            fattureSearchComplete: true,
        }, () => this.getFatture(true))
    }

    getFatture = (isSearch) => {
        const form = {
            dataDa: this.state.dataDa,
            dataA: this.state.dataA,
            importoDa: this.state.importoDa,
            importoA: this.state.importoA,
            codiceCliente: this.state.cliente ? this.state.cliente.codiceCliente : ''
        }
        fetch(`/api/versamenti/fatture`, {   
            method: 'POST',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Sets the body of the call
            body: JSON.stringify(form)
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            console.log(myjson)
            if(isSearch){
                this.setState({
                    searchFatture: myjson
                })
            }
            else{
                this.setState({
                    fatture: myjson
                })
            }
            
        }).catch(e => {

        });
    }
    handleFilterChange = (e) => {    
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleCancelSearch = () => {
        this.setState({
            dataDa: this.state.historicalFilter.dataDa,
            dataA: this.state.historicalFilter.dataA,
            importoDa: this.state.historicalFilter.importoDa,
            importoA: this.state.historicalFilter.importoA,
        })
    }

    getTitoloPagamenti = () => {
        fetch(`/api/versamenti/titoloPagamenti`, {   
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            this.setState({
                titoloPagamenti: myjson
            })
        }).catch(e => {

        });
    }
    toggleTitoloPagamenti = () => {
        this.setState({
            titoloPagamentiDropdown: !this.state.titoloPagamentiDropdown
        })
    }
    dropdownOnSelect = (pagamento) => {
        this.setState({
            textTitoloDropdown: pagamento.descrizione,
            titoloPagamentoId: pagamento.titoloPagamentoId
        })
    }

    handleAnnulla = () => {
        this.setState({
            clienti: [],
            searchClienti: [],
            fatture: [],
            searchFatture: [],
            fattura: null,
            titoloPagamenti: [],
            textTitoloDropdown: 'Scegli un Titolo Pagamento',
            note: '',
            cliente: null,
            importo: '',
            dataDa: '',
            dataA: '',
            importoDa: '',
            importoA: '',
            historicalFilter: {
                dataDa: '',
                dataA: '',
                importoDa: '',
                importoA: '',
            }
        }, this.toggleEntryModal())
    }

    handleVai = () => {
        if(this.state.cliente && this.state.fatt && this.state.importo > 0 && this.state.textTitoloDropdown !== 'Scegli un Titolo Pagamento'){
            const form = {
               // fatturaId: this.state.fattura.fatturaId,
                importo: this.state.importo,
                codiceCliente: this.state.cliente.codiceCliente,
                titoloPagamentoId: this.state.titoloPagamentoId,
                note: this.state.note,
                fatt: this.state.fatt
            }

            fetch(`/api/versamenti/add`, {   
                method: 'POST',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Sets the body of the call
                body: JSON.stringify(form)
                //Changes the response to an object
            }).then(response => {
                if(response.status >= 200 && response.status < 300){
                    this.setState({
                        clienti: [],
                        searchClienti: [],
                        fatture: [],
                        searchFatture: [],
                        fattura: null,
                        titoloPagamenti: [],
                        textTitoloDropdown: 'Scegli un Titolo Pagamento',
                        note: '',
                        cliente: null,
                        importo: '',
                        dataDa: '',
                        dataA: '',
                        importoDa: '',
                        importoA: '',
                        historicalFilter: {
                            dataDa: '',
                            dataA: '',
                            importoDa: '',
                            importoA: '',
                        }
                    }, this.toggleEntryModal())
                }
                else{
                    throw Error("Server Error");
                }
            }).catch(e => {
                this.setState({
                    errore: `Errore: Prova ancora una volta`
                }, () => this.toggleErrorModal())
            });

            
        }
        else{
            let errorMessage = "Controlla il modulo e riprova";

            if(!this.state.fattura){
                errorMessage = `Verifica che sia selezionata una fattura`;
            }
            else if(!(this.state.importo > 0)){
                errorMessage = `Si controlla l'importo`;
            }
            else if(!(this.state.importo > 0)){
                errorMessage = `Verifica che sia stato selezionato un titolo pagamento.`;
            }

            this.setState({
                errore: errorMessage
            }, () => this.toggleErrorModal())
        }
    }

    toggleErrorModal = () => {
        this.setState({
            errorModal: !this.state.errorModal
        })
    }

    getPdf = (e, id) => {
        e.preventDefault();

        fetch(`../api/clienti/fatture/${id}`, {   
            method: 'Get',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
            }),
            //Changes the response to an object
        }).then(response => response.blob())
        .then(blob => {
            window.open(URL.createObjectURL(blob))
        }).catch(e => {
            console.log(e);
        });

     }

    viewVersamento = (versamento) => {
        this.setState({
            isView: true,
            versamento: versamento,
            cliente: versamento.cliente,
            fattura: versamento.fattura,
            importo: versamento.importo,
            textTitoloDropdown: versamento.titoloPagamento,
            note: versamento.note,
        }, () => this.toggleEntryModal())
    }

    handleApprova = (nonApprov) => {
        console.log(this.state.versamento)
        const form = {
            versamentoId: this.state.versamento.versamentoId,
            nonApprov: nonApprov,
            note: this.state.note
        }
        fetch(`/api/versamenti/approve`, {   
            method: 'POST',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Sets the body of the call
            body: JSON.stringify(form)
            //Changes the response to an object
        }).then(response => {
            if(response.status >= 200 && response.status < 300){
                this.toggleEntryModal();
            }
            else{
                throw Error("Server Error");
            }
        }).catch(e => {
            this.setState({
                errore: `Errore: Prova ancora una volta`
            }, () => this.toggleErrorModal());
        });
    }

    handleDelete = (versamentoId) => {
        fetch(`/api/versamenti/delete/${versamentoId}`, {   
            method: 'DELETE',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => {
            if(response.status >= 200 && response.status < 300){
                this.getVersamenti();
            }
            else{
                throw Error("Server Error");
            }
        }).catch(e => {
            this.setState({
                errore: `Errore: Prova ancora una volta`
            }, () => this.toggleErrorModal());
        });
    }
    /**
     * Renders the page
     */
    render() {

        const titolo = (
            <h5 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Nuovi Versamenti</h5>
        );

        return (
            <Container fluid style={{minHeight: '75vh'}}> 
                <Container className="d-flex align-items-center" fluid> 
                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                        <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                            {titolo}
                        </Col>
                    </Row>
                </Container>
                {sessionStorage.getItem('selectedRole') === 'Agenti' ?
                    <Container className="d-flex align-items-center" fluid>
                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                            <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", borderBottom: "1px solid #011e41", marginTop: "10px"}}>
                                <Button type="button" className="text-center" onClick={() => this.toggleEntryModal(true)} style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                    Aggiungi un nuovo versamento
                                </Button>                                    
                            </Col>
                        </Row> 
                    </Container> : null
                }       
                <Container className="d-flex align-items-center" fluid>
                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px"}}>
                        <Col className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                            <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Versamenti in Attesa</h4>
                        </Col>
                    </Row>
                </Container> 
                <Container className="d-flex align-items-center" fluid>
                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", borderBottom: "1px solid #011e41"}}>
                        <Col className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                            <Table responsive borderless style={{margin: "0", marginTop: "5px"}}>
                                <thead>
                                    <tr>
                                        <th style={{padding: "0", width: "14%"}}>Versamento Id</th>
                                        <th style={{padding: "0", width: "14%"}}>Codice Cliente</th>
                                        <th style={{padding: "0", width: "16%"}}>Cliente</th>
                                        <th style={{padding: "0", width: "14%"}}>Importo</th>
                                        <th style={{padding: "0", width: "14%" }}>Data</th>
                                        {sessionStorage.getItem('selectedRole') === 'Amministrazione' ? <th style={{ padding: "0", width: "14%" }}>Agente</th> : null }
                                        <th style={{padding: "0", width: "14%"}}>Stato</th>
                                        <th style={{padding: "0", width: "14%"}}>Partita</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.pendingVersamenti.map((versamento, index) => {
                                            return(
                                                <tr key={index}>
                                                    <td align="left" style={{padding: "0"}}><a style={{padding: "0", color: "blue", cursor: "pointer"}} onClick={() => this.viewVersamento(versamento)}>{versamento.versamentoId}</a></td>
                                                    <td align="left" style={{padding: "0"}}>{versamento.cliente.codiceCliente}</td>
                                                    <td align="left" style={{padding: "0"}}>{versamento.cliente.ragSoc}</td>
                                                    <td align="left" style={{padding: "0"}}>{versamento.importo}</td>
                                                    <td align="left" style={{padding: "0"}}>{new Date(versamento.dataVersimento).toLocaleDateString()}</td>
                                                    {sessionStorage.getItem('selectedRole') === 'Amministrazione' ? <td align="left" style={{ padding: "0" }}>{versamento.agente}</td> : null}
                                                    <td align="left" style={{ padding: "0" }}>{versamento.status}</td>
                                                    <td align="left" style={{padding: "0"}}>{versamento.fattura}</td>
                                                </tr> 
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
                    {sessionStorage.getItem('selectedRole') === 'Agenti' ?
                        <div>
                            <Container className="d-flex align-items-center" fluid>
                                <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px"}}>
                                    <Col className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                                        <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Versamenti Non Approvati</h4>
                                    </Col>
                                </Row>
                            </Container> 
                            <Container className="d-flex align-items-center" fluid>
                                <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px"}}>
                                    <Col className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                                        <Table responsive borderless style={{margin: "0", marginTop: "5px"}}>
                                            <thead>
                                                <tr>
                                                    <th style={{padding: "0", width: "14%"}}>Versamento Id</th>
                                                    <th style={{padding: "0", width: "14%"}}>Codice Cliente</th>
                                                    <th style={{padding: "0", width: "16%"}}>Cliente</th>
                                                    <th style={{padding: "0", width: "14%"}}>Importo</th>
                                                    <th style={{padding: "0", width: "14%"}}>Data</th>
                                                    <th style={{padding: "0", width: "14%"}}>Stato</th>
                                                    <th style={{padding: "0", width: "14%"}}>Note</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                this.state.nonApprovVersamenti.map((versamento, index) => {
                                                    return(
                                                        <tr>
                                                            <td align="left" style={{padding: "0"}}>
                                                            <Button type="submit" onClick={() => this.handleDelete(versamento.versamentoId)} style={{width: "10%", padding: "0px", color: "#011e41", border: "none", backgroundColor: "transparent", marginLeft: "5px", marginRight: "10px"}}><i className="fa fa-trash" aria-hidden="true"></i></Button>
                                                                {versamento.versamentoId}
                                                            </td>
                                                            <td align="left" style={{padding: "0"}}>{versamento.cliente.codiceCliente}</td>
                                                            <td align="left" style={{padding: "0"}}>{versamento.cliente.ragSoc}</td>
                                                            <td align="left" style={{padding: "0"}}>{versamento.importo}</td>
                                                            <td align="left" style={{padding: "0"}}>{new Date(versamento.dataVersimento).toLocaleDateString()}</td>
                                                            <td align="left" style={{padding: "0"}}>{versamento.status}</td>
                                                            <td align="left" style={{padding: "0"}}>{versamento.note}</td>
                                                        </tr> 
                                                    )
                                                })
                                            } 
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </Container> 
                        </div> : null
                    }
                <Modal size="lg" isOpen={this.state.entryModal} toggle={this.toggleEntryModal} style={{color: "#011e41"}}>
                    <ModalBody>
                        <Container>
                            <Row style={{margin: "0px", padding: "0px"}}>
                                <Col className="d-flex align-items-center justify-content-start" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                    <Table responsive borderless style={{width: "80%", margin: "0", marginTop: "5px"}}>
                                        <tbody style={{fontSize: "20px"}}>                                     
                                            <tr>
                                                <th style={{width: "40%", padding: "5px", paddingRight: "20px", textAlign: "right"}}>Cliente:  </th>
                                                <td align="left" style={{padding: "5px" }}>
                                                    <div>
                                                        {this.state.cliente ?
                                                            <div>{`${this.state.cliente.codiceCliente} - ${this.state.cliente.ragSoc}`}</div> :
                                                            <Button className="text-center" style={{width: '75%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={this.toggleClienteSelectModal}>
                                                                Seleziona un cliente
                                                            </Button> 
                                                        }   
                                                    </div>                 
                                                </td>
                                            </tr>
                                            {this.state.cliente ?
                                                <tr>
                                                    <th style={{width: "40%", padding: "5px", paddingRight: "20px", textAlign: "right"}}>Partita:  </th>
                                                    <td align="left" style={{padding: "5px"}}>
                                                        {sessionStorage.getItem("selectedRole") === "Amministrazione" || this.state.isView ?
                                                            <div>
                                                                {this.state.fattura}
                                                            </div> :
                                                            <div>
                                                                <Input id="fatt" name="fatt" type="month" onChange={this.handleFilterChange} value={this.state.fatt} style={{height: "35px", width: "75%", padding: "0px", paddingLeft: "5px", fontSize: "20px", color: "#011e41", borderColor: "#011e41"}}/>
                                                            </div>
                                                            /*<div>
                                                                {this.state.fattura ? `${this.state.fattura.fatturaId} - € ${this.state.fattura.importo} - ${new Date(this.state.fattura.dataFattura).toLocaleDateString()}` : ''}
                                                            </div> :
                                                            <div>
                                                                <Button className="text-center" style={{width: '75%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={this.toggleFatturaModal}>
                                                                    {this.state.fattura ? `${this.state.fattura.fatturaId} - € ${this.state.fattura.importo} - ${new Date(this.state.fattura.dataFattura).toLocaleDateString()}` : 'Seleziona una fattura'}
                                                                </Button>
                                                            </div>*/
                                                        }
                                                                     
                                                    </td>
                                                </tr> 
                                                : null
                                            }
                                            {this.state.cliente ?
                                                <tr>
                                                    <th style={{width: "40%", padding: "5px", paddingRight: "20px", textAlign: "right"}}>Importo:  </th>
                                                    <td align="left" style={{padding: "5px"}}>
                                                        {sessionStorage.getItem("selectedRole") === "Amministrazione" || this.state.isView ?
                                                            <div>
                                                                {this.state.importo}
                                                            </div> :
                                                            <div>
                                                                <Input id="importo" name="importo" type="number" onChange={this.handleFilterChange} value={this.state.importo} style={{height: "35px", width: "75%", padding: "0px", paddingLeft: "5px", fontSize: "20px", color: "#011e41", borderColor: "#011e41"}}/>                 
                                                            </div>
                                                        }
                                                    </td>
                                                </tr> 
                                                : null
                                            }
                                            {this.state.cliente ?
                                                <tr>
                                                    <th style={{width: "40%", padding: "5px", paddingRight: "20px", textAlign: "right"}}>Titolo Pagamento:  </th>
                                                    <td align="left" style={{padding: "5px"}}>
                                                        {sessionStorage.getItem("selectedRole") === "Amministrazione" || this.state.isView ?
                                                            <div>
                                                                {this.state.textTitoloDropdown}
                                                            </div> :
                                                            <div>
                                                                <Dropdown style={{width: '100%'}} isOpen={this.state.titoloPagamentiDropdown} toggle={this.toggleTitoloPagamenti}>
                                                                    <DropdownToggle caret style={{width: '75%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                                                        {this.state.textTitoloDropdown}
                                                                    </DropdownToggle>
                                                                    <DropdownMenu right 
                                                                        modifiers={{
                                                                            setMaxHeight: {
                                                                            enabled: true,
                                                                            order: 890,
                                                                            fn: (data) => {
                                                                                return {
                                                                                ...data,
                                                                                styles: {
                                                                                    ...data.styles,
                                                                                    overflow: 'auto',
                                                                                    maxHeight: "50vh",
                                                                                },
                                                                                };
                                                                            },
                                                                            },
                                                                            computeStyle: {
                                                                                gpuAcceleration: false
                                                                            }
                                                                        }}> 
                                                                        {this.state.titoloPagamenti.map(pagamento => {
                                                                            return (
                                                                                <DropdownItem key={pagamento.titoloPagamentoId} id={pagamento.titoloPagamentoId} onClick={() => this.dropdownOnSelect(pagamento)} style={{color: "#011e41"}}>
                                                                                    {`${pagamento.descrizione}`}
                                                                                </DropdownItem>
                                                                            )
                                                                        })}
                                                                    </DropdownMenu>
                                                                </Dropdown > 
                                                            </div>  
                                                        }
                                                    </td>
                                                </tr> 
                                                : null
                                            }
                                            {this.state.cliente ?
                                                <tr>
                                                    <th style={{width: "40%", padding: "5px", paddingRight: "20px", textAlign: "right"}}>Note:  </th>
                                                    <td align="left" style={{padding: "5px"}}>
                                                        {sessionStorage.getItem("selectedRole") === "Amministrazione" || !this.state.isView ?
                                                            <div>
                                                                <Input id="note" name="note" type="textarea" onChange={this.handleFilterChange} value={this.state.note} style={{height: "25vh", width: "100%", padding: "0px", paddingLeft: "5px", fontSize: "20px", color: "#011e41", borderColor: "#011e41"}}/>
                                                            </div>
                                                            :
                                                            <div>
                                                                {this.state.note}
                                                            </div> 
                                                        }
                                                    </td>
                                                </tr> 
                                                : null
                                            }
                                        </tbody>
                                    </Table> 
                                    
                                </Col>
                            </Row>
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            {this.state.isView && sessionStorage.getItem("selectedRole") === "Agenti" ? 
                                <Button className="text-center" onClick={this.handleAnnulla} style={{width: '35%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                    Ok
                                </Button> :
                                <Container className="d-flex justify-content-center align-items-center">
                                    {sessionStorage.getItem("selectedRole") === "Amministrazione" ? 
                                        <Container className="d-flex justify-content-center align-items-center">
                                            <Button className="text-center" onClick={() => this.handleApprova(true)} style={{width: '35%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                                Disapprova
                                            </Button>
                                            <Button className="text-center" onClick={() => this.handleApprova(false)} style={{width: '35%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                                Approva
                                            </Button>
                                        </Container> :
                                        <Container className="d-flex justify-content-center align-items-center">
                                            <Button className="text-center" onClick={this.handleAnnulla} style={{width: '35%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                                Annulla
                                            </Button>
                                            {this.state.cliente ?
                                                <Button className="text-center" onClick={this.handleVai} style={{width: '35%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                                    Vai
                                                </Button> : null
                                            }
                                        </Container>
                                     } 
                                </Container>
                            }
                            
                        </Container>
                    </ModalFooter>
                </Modal>    
                <Modal size="md" isOpen={this.state.clientiModal} toggle={this.toggleClienteSelectModal} style={{color: "#011e41"}}>
                    <ModalBody>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <SelectCliente 
                                clienti={this.state.clienti}
                                searchClienti={this.state.searchClienti}
                                searchCodiceClienti={this.state.searchCodiceClienti}
                                searchComplete={this.state.searchComplete}
                                searchCodiceComplete={this.state.searchCodiceComplete}
                                clienteSelected={this.clienteSelected}
                                clienteSearch={this.clienteSearch}
                                clienteCodiceSearch={this.clienteCodiceSearch}
                            />
                        </Container>
                    </ModalBody>
                </Modal>
                <Modal size="md" isOpen={this.state.fatturaModal} toggle={this.toggleFatturaModal} style={{color: "#011e41"}}>
                    <ModalBody>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <SelectFattura 
                                fatture={this.state.fatture}
                                searchFatture={this.state.searchFatture}
                                searchComplete={this.state.fattureSearchComplete}
                                dataDa={this.state.dataDa}
                                dataA={this.state.dataA}
                                importoDa={this.state.importoDa}
                                importoA={this.state.importoA}
                                fatturaSelected ={this.fatturaSelected}
                                fatturaSearch={this.fatturaSearch}
                                handleFilterChange={this.handleFilterChange}
                                handleCancelSearch={this.handleCancelSearch}
                            />
                        </Container>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.errorModal} toggle={this.toggleErrorModal} style={{color: "#011e41"}}>
                    <ModalBody>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            {this.state.errore}
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Button className="text-center" style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={() => this.setState({errorModal: false})}>
                                Ok
                            </Button>
                        </Container>
                    </ModalFooter>
                </Modal>
            </Container> 
            
        )
    }
}

export default NuovoVersamentiContainer


//<td align="left" style={{padding: "0"}}><a style={{padding: "0", color: "blue", cursor: "pointer"}} onClick={(e) => this.getPdf(e, versamento.fattura.fatturaId)}>{versamento.fattura.fatturaId}</a></td>    VISULIZZAZIONE FATTURA IN PDF          


// WEBPACK FOOTER //
// ./src/containers/NuovoVersamentiContainer.js